import { Context } from '@obvio/app'
import { Modal } from '@obvio/ui'

import { EventRegisterForm } from './EventRegisterForm'

import type { EventRegisterFormProps } from './EventRegisterForm'
import type { ReactElement } from 'react'

export function EventRegisterModal({
  id,
  title,
  rodoRequired,
  hasPlaceLeft,
  date,
  place,
  placeUrl,
  close,
  open,
  onNewClick,
  accept,
}: EventRegisterFormProps & { open: boolean; close(): void }): ReactElement {
  return (
    <Context name="eventRegisterModal">
      <Modal onClose={close} open={open}>
        <EventRegisterForm
          id={id}
          hasPlaceLeft={hasPlaceLeft}
          accept={accept}
          placeUrl={placeUrl}
          place={place}
          date={date}
          title={title}
          rodoRequired={rodoRequired}
          onNewClick={onNewClick}
          modal
        />
      </Modal>
    </Context>
  )
}
